import { description, disabled, iconContainer, item, selected, selectedIconContainer, label, imageContainer, itemImage, textContainer, componentTop, visualPicker, footer, footerDisabled, footerLeft, footerRight, } from '../styles/legacy';
import { description as descriptionCitron, disabled as disabledCitron, iconContainer as iconContainerCitron, item as itemCitron, selected as selectedCitron, selectedIconContainer as selectedIconContainerCitron, label as labelCitron, imageContainer as imageContainerCitron, itemImage as itemImageCitron, textContainer as textContainerCitron, componentTop as componentTopCitron, visualPicker as visualPickerCitron, footer as footerCitron, footerDisabled as footerDisabledCitron, footerLeft as footerLeftCitron, footerRight as footerRightCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var Description = citrusStyled.div('description', { legacy: description, citrus2022: descriptionCitron }, { classNames: ['vp-item-description-2l34kj'] });
export var IconContainer = citrusStyled.div('iconContainer', { legacy: iconContainer, citrus2022: iconContainerCitron }, { classNames: ['vp-item-user-icon-2l34kj'] });
export var SelectedIconContainer = citrusStyled.div('selectedIconContainer', {
    legacy: selectedIconContainer,
    citrus2022: selectedIconContainerCitron,
});
export var Label = citrusStyled.div('label', { legacy: label, citrus2022: labelCitron }, { classNames: ['visual-picker-label'] });
export var ImageContainer = citrusStyled.div('imageContainer', {
    legacy: imageContainer,
    citrus2022: imageContainerCitron,
});
export var TextContainer = citrusStyled.div('textContainer', {
    legacy: textContainer,
    citrus2022: textContainerCitron,
});
export var VisualPicker = citrusStyled.div('visualPicker', { legacy: visualPicker, citrus2022: visualPickerCitron });
export var Footer = citrusStyled.span('footer', { legacy: footer, citrus2022: footerCitron });
export var FooterDisabled = citrusStyled.span('footerDisabled', {
    legacy: footerDisabled,
    citrus2022: footerDisabledCitron,
});
export var FooterLeft = citrusStyled.span('footerLeft', { legacy: footerLeft, citrus2022: footerLeftCitron });
export var FooterRight = citrusStyled.span('footerRight', { legacy: footerRight, citrus2022: footerRightCitron });
export var ItemImage = citrusStyled.img('itemImage', { legacy: itemImage, citrus2022: itemImageCitron });
export var Item = citrusStyled.button('item', { legacy: item, citrus2022: itemCitron });
export var ComponentTop = citrusStyled.span('componentTop', { legacy: componentTop, citrus2022: componentTopCitron });
export var Selected = citrusStyled.button('selected', { legacy: selected, citrus2022: selectedCitron });
export var Disabled = citrusStyled.div('disabled', { legacy: disabled, citrus2022: disabledCitron });
export var Styled = {
    Description: Description,
    Disabled: Disabled,
    IconContainer: IconContainer,
    SelectedIconContainer: SelectedIconContainer,
    Selected: Selected,
    Item: Item,
    ItemImage: ItemImage,
    Footer: Footer,
    FooterDisabled: FooterDisabled,
    FooterRight: FooterRight,
    FooterLeft: FooterLeft,
    ImageContainer: ImageContainer,
    Label: Label,
    ComponentTop: ComponentTop,
    TextContainer: TextContainer,
    VisualPicker: VisualPicker,
};
